import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { GetVesselsResponse } from "@rightship-tech/document-management-app/models/my-vessels.models";
import { autoinject } from "aurelia-framework";

@autoinject()
export class MyVesselService {
    public myVesselApi: string = `${this.configService.config.urls.myVesselsApiUrl}/api/v1/MyVessel`;
    
    constructor(private requestClientService: RequestClientService, private configService: ConfigService) { }

    //Get my vessels count
    public async countMyVessel(): Promise<number> {
        try {
            return await this.requestClientService.get<number>(`${this.myVesselApi}/CountMyVessel`, {});
        }
        catch (e) {
            console.error(e);
        }
    }

    //Get my vessels
    public async getMyVessels(): Promise<GetVesselsResponse> {
        try {
            return await this.requestClientService.get<GetVesselsResponse>(`${this.myVesselApi}/GetMyVessels`, {});
        }
        catch (e) {
            console.error(e);
        }
    }

}
